import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.375 1.5H10.004C10.269 1.5 10.524 1.605 10.711 1.793L13.332 4.414C13.52 4.602 13.625 4.856 13.625 5.121V13.5C13.625 14.052 13.177 14.5 12.625 14.5H3.375C2.823 14.5 2.375 14.052 2.375 13.5V2.5C2.375 1.948 2.823 1.5 3.375 1.5Z",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.744 7.003C4.861 7.157 5.013 7.28 5.188 7.362C5.363 7.444 5.554 7.483 5.747 7.475C6.362 7.475 6.861 7.101 6.861 6.64C6.861 6.18 6.362 5.806 5.747 5.806C5.132 5.806 4.634 5.431 4.634 4.97C4.634 4.509 5.132 4.135 5.747 4.135C5.94 4.127 6.132 4.166 6.306 4.248C6.481 4.331 6.633 4.454 6.75 4.607",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.747 7.479V8.035",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.747 3.583V4.139",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.416,
			y: 9.512,
			width: 7.167,
			height: 1,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.416,
			y: 11.492,
			width: 7.167,
			height: 1,
			rx: .5,
			fill: "currentColor"
		})
	]
});
export default SvgLoan;
